import AdvisorContactCard from '@components/Card/AdvisorContactCard';
import Block from '@components/Layout/Block';
import { VerticalLineSeparator } from '@components/MiscComponents/VerticalLineSeparator';
import Video from '@components/Video';
import { FC, useEffect, useRef, useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import { A11y, Pagination } from 'swiper/modules';
import Swiper from 'swiper';

import {
  VideoGalleryHeadline,
  VideoGallerySwiper,
  VideoGallerySwiperButtonWrapper,
  VideoGallerySwiperSlide,
  VideoGallerySwiperWrapper,
} from './style';

import { VideoWrapper } from '../styles';

export interface VideoGalleryProps {
  header?: string;
  videos: any[];
}

const VideoGallery: FC<VideoGalleryProps> = ({ header, videos }) => {
  //create an array of objects to prepare data for gallery
  const mappedVideosArray = videos.map((video) => {
    return {
      video_key: video?.sys?.id,
      videoSubject: video?.fields?.videoSubject,
      videoIcon: video?.fields?.videoIcon?.fields?.file?.url,
      videoSubjectDetails: video?.fields?.videoSubjectDetails,
      muteVideo: video?.fields?.muteVideo ?? true,
      posterImage: video?.fields?.videoReference?.fields?.posterImage?.fields?.file?.url,
      video_source: video?.fields?.videoReference?.fields?.video_source,
      videoUpload: video?.fields?.videoReference?.fields?.videoUpload?.fields?.file?.url,
      youTubeUrl: video?.fields?.videoReference?.fields?.youTubeUrl,
    };
  });

  //map over videos to create

  Swiper.use([Pagination, A11y]);

  //make reference for swiper pagination
  const swiperPaginationRef = useRef(null);
  const swiperRef = useRef<Swiper | null>(null);

  //state for current active slide
  const [currentSlide, setCurrentSlide] = useState(0);
  //set playing state for each video
  const [playing, setPlaying] = useState(mappedVideosArray.map(() => true));
  const [muted, setMuted] = useState(mappedVideosArray.map((v) => v?.muteVideo));
  useEffect(() => {
    if (swiperRef.current) {
      setCurrentSlide(swiperRef.current.activeIndex);
    }
  }, [swiperRef.current]);

  //
  //function to render video pagination buttons
  const renderBullet = (index: number, className: string) => {
    const video = mappedVideosArray[index]!;
    return `<button class=${className}>
        ${ReactDOMServer.renderToString(
          <AdvisorContactCard
            header={video.videoSubject}
            img={video.videoIcon}
            subheaders={video.videoSubjectDetails}
          />,
        )}
      </button>`;
  };

  //Renders the swiper instance
  useEffect(() => {
    swiperRef.current = new Swiper('.swiper-videogallery-container', {
      spaceBetween: 0,
      slidesPerView: 1,
      pagination: {
        clickable: true,
        el: swiperPaginationRef.current,
        renderBullet: renderBullet,
      },
      on: {
        slideChange: function () {
          const index = (this as any).activeIndex;
          setCurrentSlide(index);
          // set all in mappedVideosArray to false except for the activeIndex
          setPlaying(
            mappedVideosArray.map((video, index) => {
              return index === index ? true : false;
            }),
          );
        },
      },
    });

    // Cleanup function
    return () => {
      swiperRef?.current?.destroy();
    };
  }, [videos]);
  return (
    <Block fullOnMobile>
      <VideoGalleryHeadline>{header}</VideoGalleryHeadline>

      <VerticalLineSeparator />

      <VideoGallerySwiperWrapper>
        <VideoGallerySwiper className="swiper-videogallery-container">
          {mappedVideosArray.map((video, index) => {
            return (
              <VideoGallerySwiperSlide key={video.video_key}>
                <VideoWrapper>
                  <Video
                    video_source={video.video_source}
                    youTubeUrl={video.youTubeUrl}
                    videoUpload={video.videoUpload}
                    posterImage={video.posterImage}
                    controls={true}
                    playing={playing[index]}
                    muted={muted[index]}
                  />
                </VideoWrapper>
              </VideoGallerySwiperSlide>
            );
          })}
        </VideoGallerySwiper>
        <VideoGallerySwiperButtonWrapper ref={swiperPaginationRef} />
      </VideoGallerySwiperWrapper>
    </Block>
  );
};

export default VideoGallery;
